import React, { useCallback } from 'react';
import { Box, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROLES } from '../constants/roles';
import { useModuleViewAccess } from '../hooks/useModuleViewAccess';
import ProcurementModule from './store/ProcurementModule';
import WorkflowGuide from './common/WorkflowGuide';

const STORE_ACCESS_ROLES = [
  ROLES.STORE_EXECUTIVE,
  ROLES.STORE_INSPECTOR,
  ROLES.CA_MANAGER,
  ROLES.MRO_MANAGER,
  ROLES.CAMO_QM_MANAGER,
  ROLES.PLANNING_MANAGER,
  ROLES.ACCOUNTABLE_MANAGER,
  ROLES.SUPER_ADMIN
];

const Procurement = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { hasAccess } = useModuleViewAccess('procurement', STORE_ACCESS_ROLES);

  const clearProcurementDeepLink = useCallback(() => {
    const prev = location.state;
    if (!prev?.procurement) return;
    const next = { ...prev };
    delete next.procurement;
    const keys = Object.keys(next);
    navigate('.', { replace: true, state: keys.length ? next : undefined });
  }, [location.state, navigate]);

  if (!hasAccess) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" color="error">
          Access Denied
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          You do not have permission to access Procurement.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Procurement
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Purchase orders, vendors, and procurement workflows
      </Typography>
      <WorkflowGuide variant="procurement" />
      <ProcurementModule
        deepLinkPoForm={location.state?.procurement || null}
        onDeepLinkPoFormConsumed={clearProcurementDeepLink}
      />
    </Box>
  );
};

export default Procurement;
